import script from "./ShareNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareNotice.vue?vue&type=script&setup=true&lang=js"

import "./ShareNotice.vue?vue&type=style&index=0&id=1a5613bb&lang=css"

const __exports__ = script;

export default __exports__